import { Skeleton } from "@/shared/ui/core/Skeleton";
import { Loading } from "@/shared/ui/core/Loading";
import { cn } from "@/shared/lib/cn";

export interface LoadingStateProps {
  label?: string;
  variant?: "skeleton" | "spinner" | "both";
  className?: string;
}

export function LoadingState({
  label = "Đang tải…",
  variant = "skeleton",
  className,
}: LoadingStateProps) {
  if (variant === "spinner") {
    return (
      <div
        aria-busy="true"
        aria-label={label}
        className={cn("flex items-center justify-center p-8", className)}
      >
        <Loading size="lg" label={label} direction="vertical" />
      </div>
    );
  }

  if (variant === "both") {
    return (
      <div
        aria-busy="true"
        aria-label={label}
        className={cn("space-y-4 p-4", className)}
      >
        <div className="flex items-center justify-center py-2">
          <Loading size="md" label={label} />
        </div>
        <Skeleton variant="table" rows={4} />
      </div>
    );
  }

  return (
    <div aria-busy="true" aria-label={label} className={className}>
      <Skeleton variant="table" rows={4} />
    </div>
  );
}

